import type { RoofGenerationStageInput, RoofGenerationStageResult } from "building-types/roofs/roofGenerationTypes";
import { buildRoofPerimeterRails } from "../roofPerimeterRails";

/**
 * Generates the roof perimeter rails, with all the needed information for generating
 * later the roof trims
 */
export function generateRoofPerimeterRails({
  subRoofOptions,
  subRoof,
}: RoofGenerationStageInput): RoofGenerationStageResult {
  const { roofInputSettings } = subRoofOptions;
  const { roofVolume, id: subRoofId, roofSettings, isDormer } = subRoof;
  const { extensions, shedExtensions, rails, edges, exactEdges, roofTopFaces } = roofVolume;

  const { peakRail: peakRail3 } = rails;
  const { wallSettings } = roofInputSettings;

  const srcRoofPerimeterRails = buildRoofPerimeterRails({
    subRoofId,
    exactEdges,
    edges,
    roofSettings,
    wallSettings,
    extensions,
    shedExtensions,
    roofTopFaces,
    peakRail: peakRail3,
    isDormer,
  });

  return {
    subRoof: {
      srcRoofPerimeterRails,
      roofPerimeterRails: srcRoofPerimeterRails,
    },
  };
}
